<script>
export default {
    name: 'ComponentsFooter',
}
</script>
<template>
    <div class="d-flex flex-1 flex-column">
        <div class="d-flex flex-1 justify-content-center">
            <strong>Kontakt w sprawach technicznych:</strong>&nbsp; biuro@adriannasobol.pl
        </div>
        <footer>
            <div class="container">
                <div class="text-center">
                    &copy; {{ (new Date()).getFullYear() }}
                </div>
            </div>
        </footer>
    </div>
</template>
